/**
*
* Container
*
*/

import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  max-width: ${(props) => props.width ?? '908px'};
  margin: auto;
`;

Container.propTypes = {
  width: PropTypes.string,
};

export default Container;
